<template>
  <section class="mobile-block-screen">
    <header class="mobile-block-header flex flex-center bg-white q-px-md q-py-md">
      <app-logo />
    </header>

    <main class="mobile-block-body flex column items-center">
      <section class="mobile-block-content flex column items-center q-mb-md text-center">
        <div class="icon-badge">
          <lucide-icon
            name="monitor-smartphone"
            size="40px"
            color="brand"
            :stroke-width="1.5"
            aria-hidden="true"
          />
        </div>

        <h1 class="text-24 text-primary text-font-bold line-height-base">
          Built for the big screen
        </h1>

        <p class="text-14 text-info line-height-md">
          This portal is optimized for desktop. Switch to your computer to use the portal.
        </p>
      </section>
      <section class="mobile-block-actions flex column items-center">
        <q-btn
          unelevated
          no-caps
          color="brand"
          text-color="white"
          class="copy-link-btn sm-radius text-font-medium"
          @click="onCopyLink"
        >
          <lucide-icon
            :name="linkCopied ? 'check' : 'copy'"
            size="16px"
            color="white"
            class="q-mr-xs"
          />
          {{ linkCopied ? 'Link copied' : 'Copy link to clipboard' }}
        </q-btn>

        <a
          href="https://www.armadillex.com"
          target="_blank"
          rel="noopener noreferrer"
          class="website-link text-14 text-brand text-font-medium"
        >
          Learn more about Armadillex
          <lucide-icon
            name="external-link"
            size="14px"
            class="q-ml-xxs"
          />
        </a>
      </section>
    </main>
  </section>
</template>

<script setup>
  import { ref } from 'vue'

  import AppLogo from 'src/components/common/AppLogo.vue'
  import LucideIcon from 'src/components/common/LucideIcon.vue'

  const linkCopied = ref(false)

  function onCopyLink() {
    navigator.clipboard.writeText(window.location.href).then(() => {
      linkCopied.value = true
      setTimeout(() => {
        linkCopied.value = false
      }, 2500)
    })
  }
</script>

<style lang="scss">
  .mobile-block-screen {
    position: fixed;
    inset: 0;
    z-index: 200000;

    display: flex;
    flex-direction: column;

    height: 100vh;
    height: 100dvh;

    .mobile-block-header {
      flex-shrink: 0;
      box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.08);
    }

    .mobile-block-body {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      justify-content: center;
      padding: 2.5rem 1.5rem;
      background: linear-gradient(175deg, $accent-light 0%, white 50%, $accent-light 100%);
    }

    .mobile-block-content {
      max-width: 22rem;
      gap: 1.25rem;
    }

    .icon-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 5rem;
      height: 5rem;
      border-radius: 1.5rem;
      background: rgba($brand, 0.08);
      border: 1px solid rgba($brand, 0.12);
      margin-bottom: 0.25rem;
    }

    .mobile-block-actions {
      margin-top: 0.5rem;
      gap: 0.75rem;
    }

    .website-link {
      display: inline-flex;
      align-items: center;
    }

    .logo-container {
      margin-inline-start: 0;
    }
  }
</style>
